import useSWR from 'swr';
import { fetcherWithToken } from '@/shared/api/fetcher';
import { useIsBonusActive, useBonusInfoGames } from '@/shared/providers/notifications-provider/store';

export function useCategories() {
  const isBonusActive = useIsBonusActive();
  const bonusGames = useBonusInfoGames();
  const { data, error, isLoading } = useSWR('/categories', fetcherWithToken);

  const categories = Array.isArray(data) ? data : [];
  return {
    categories:
      isBonusActive && bonusGames
        ? [
            {
              id: 'bonus',
              imageUrl: '/images/icons/category-bonus.svg',
              gamesCount: bonusGames?.length,
              rows: 1,
            },
            ...categories,
          ]
        : categories,
    isLoading: isLoading,
    isError: error,
  };
}
